export var WidgetSize;
(function (WidgetSize) {
    WidgetSize[WidgetSize["Button"] = 0] = "Button";
    WidgetSize[WidgetSize["Frame"] = 1] = "Frame";
    WidgetSize[WidgetSize["FullScreen"] = 2] = "FullScreen";
})(WidgetSize || (WidgetSize = {}));
export var WidgetPlaceholderType;
(function (WidgetPlaceholderType) {
    WidgetPlaceholderType[WidgetPlaceholderType["Docked"] = 0] = "Docked";
    WidgetPlaceholderType[WidgetPlaceholderType["Tiles"] = 1] = "Tiles";
    WidgetPlaceholderType[WidgetPlaceholderType["Floating"] = 2] = "Floating";
})(WidgetPlaceholderType || (WidgetPlaceholderType = {}));
export function getWidgets(widgets, placeholderType, placeholderName) {
    function isDockedPlacement(placement) {
        return 'panel' in placement && 'order' in placement;
    }
    function isDashboardPlacement(placement) {
        return 'section' in placement && 'order' in placement;
    }
    function isFloatingPlacement(placement) {
        return ('x' in placement &&
            'y' in placement &&
            'width' in placement &&
            'height' in placement);
    }
    function sectionMatchesName(section, name) {
        if (!name) {
            return true;
        }
        if (typeof section === 'string') {
            return section === name;
        }
        return section?.en === name || section?.cs === name;
    }
    const result = [];
    for (const widget of widgets) {
        for (const placement of widget.placement ?? []) {
            if (placeholderType === WidgetPlaceholderType.Docked &&
                isDockedPlacement(placement) &&
                (!placeholderName || placement.panel === placeholderName)) {
                result.push([widget, placement]);
                continue;
            }
            if (placeholderType === WidgetPlaceholderType.Tiles &&
                isDashboardPlacement(placement) &&
                sectionMatchesName(placement.section, placeholderName)) {
                result.push([widget, placement]);
                continue;
            }
            if (placeholderType === WidgetPlaceholderType.Floating &&
                isFloatingPlacement(placement)) {
                result.push([widget, placement]);
            }
        }
    }
    result.sort((a, b) => {
        const aPlacement = a[1];
        const bPlacement = b[1];
        if (typeof aPlacement.order === 'number' &&
            typeof bPlacement.order === 'number') {
            return aPlacement.order - bPlacement.order;
        }
        return 0;
    });
    return result;
}
